import EditableItemOverview from "@/components/molecules/inputs/EditableOverview/EditableItemOverview";
import { getStatisticValue } from "@/utils/transformUserData";
import { useAuthContext } from '@/context/AuthContext';
import { cn } from "@/lib/utils";
import { Label } from "../atoms/texts/label";
import { MAIN_CURRENCY } from "@/utils/globalConst";

let labelsOfItems = [
    {
        label: "daysWorked",
        message: "consultants.statement.overview.daysWorked",
        hasCurrency: false
    },
    {
        label: "daysSick",
        message: "consultants.statement.overview.daysSick"
    },
    {
        label: "companyBenefit",
        message: "consultants.statement.overview.companyBenefits",
        hasCurrency: true
    },
    {
        label: "expenses",
        message: "consultants.statement.overview.expenseAccount",
        hasCurrency: true
    },
    {
        label: "netMargin",
        message: "consultants.statement.overview.netMargin",
        hasCurrency: true
    },
    {
        label: "overflow",
        message: "consultants.statement.overview.globalOverflow",
        hasCurrency: true
    },
    {
        label: "grossSalary",
        message: "consultants.statement.overview.grossSalary",
        hasCurrency: true
    },
    {
        label: "employerCost",
        message: "consultants.statement.overview.totalCostEmployee",
        hasCurrency: true
    },
    {
        label: "employerContributions",
        message: "consultants.statement.overview.employerContributions",
        hasCurrency: true
    },
    // {
    //     label: "consultantServiceAmount",
    //     message: "consultants.statement.billsDetails.commission"
    // },
    { label: "taxes", message: "consultants.statement.overview.taxes", hasCurrency: true },
    {
        label: "dailyRateClient",
        message: "consultants.statement.overview.dailyRate",
        hasCurrency: true
    },
    {
        label: "dailyRateConsultant",
        message: "consultants.statement.overview.dailyRateConsultant",
        hasCurrency: true
    },
];
export default function ListOfEditableOverview({
    year,
    userActive,
    className,
    yearData,
}) {
    const { hasPrivileges } = useAuthContext();

    if (!hasPrivileges("ADMIN_STATEMENT")) {
        labelsOfItems = labelsOfItems.filter((item) => {
            // console.log("item", hasPrivileges("ADMIN_STATEMENT"), item.label != "netMargin", item.label != "dailyRateClient", item)

            return (
                (item.label != "netMargin" && item.label != "dailyRateClient") && item

            );
        });
        console.log("item", hasPrivileges("ADMIN_STATEMENT"))
    }
    
    return (
        // flex flex-col-2 items-start content-start gap-[12px] flex-shrink-0 flex-wrap
        //
        <div
            className={cn(
                "w-full  grid grid-cols-2 items-start content-start gap-[10px]  flex-shrink-0 flex-wrap min-w-[200px] ",
                className
            )}
        >
            {labelsOfItems.map((labelItem) => (
                <div key={labelItem.label} className="bg-primary text-white flex flex-col items-center justify-center gap-secondDegree pt-thirdDegree pb-secondDegree rounded-sm ">
                    <Label size="h4" fontWeight="bold">{yearData && yearData[labelItem.label]?.toLocaleString()} {labelItem.hasCurrency && MAIN_CURRENCY}</Label>
                    <Label fontWeight="semibold" size="small" message={labelItem.message} />

                </div>
            ))}
            {/* {labelsOfItems.map((labelItem) => (
                <EditableItemOverview
                    key={labelItem.label}
                    // initialValue={activeUser[labelItem.label]}
                    initialValue={yearData && yearData[labelItem.label]}
                    labelMessage={labelItem.message}
                />
            ))} */}
        </div>
    );
}
